<template>
  <modal
    class="modalLink"
    :header-text="'Привязать к контакту'"
    :button-text="'Привязать'"
    :not-active="isLoader || !selectedUser"
    :class="$style.modalLink"
    @action="addMsgr"
    @close="close()"
  >
    <div :class="$style.header">
      {{ $t('relations.linkToContact.linkUnassigned') }}
      <strong :class="$style.strong">{{ currentEmail }}</strong>
      {{ $t('relations.linkToContact.linkButton') }}
      <strong :class="$style.strong">{{ selectedUser }}</strong>
    </div>
    <loader
      v-if="isLoader"
      :class="$style.loader"
    />
    <div
      v-else
      :class="$style.wrapper"
    >
      <div :class="$style.container">
        <v-table
          :row-active-id="rowActiveId"
          :data="data"
          :columns="columns"
          clickable
          @row-click="onRowClick"
        />
      </div>
      <div :class="$style.container">
        <contact
          :comp-data="activeRow"
          @update="fetch"
        />
      </div>
    </div>
    <template v-slot:footer>
      <button
        :class="[
          $style.button,
          { [$style.none]: isLoader || !activeRow },
          { [$style.disabled]: isLoader || !activeRow },
        ]"
        @click="deleteMsgr"
      >
        Удалить
      </button>
    </template>
  </modal>
</template>

<script>
  import Modal from '@/components/common/modal/settings-modal.vue';
  import VTable from '@/components/common/table/table.vue';
  import Loader from '@/components/common/blocks/loader.vue';
  import Contact from '@/views/settings/agents/agent/settings/contact.vue';
  import { getContacts } from '@/api/methods/security';
  import { addContactMsgr, deleteContact } from '@/api/methods/settings';
  import { TYPE_DETAILS } from './const/const';

  export default {
    components: { Modal, VTable, Loader, Contact },
    props: ['currentEmail'],

    data() {
      return {
        hide: false,
        notActive: false,
        rowActiveId: null,
        isLoader: false,
        typeDetails: TYPE_DETAILS,
        compName: null,
        person: null,
        type: null,
        data: [],
        columns: [
          {
            field: 'username',
            title: this.$t('pages.columns.username'),
            sortFn: this.usernameSortFn,
          },
          { field: 'person', title: this.$t('global.FCs') },
        ],
      };
    },
    computed: {
      disabledSaveBtn() {
        return this.compName && this.type && this.person;
      },
      activeRow() {
        return this.data.find((i) => i?.id === this.rowActiveId) || {};
      },
      selectedUser() {
        return this.activeRow?.username;
      },
    },
    async created() {
      await this.fetch();
    },
    methods: {
      usernameSortFn(isAsc) {
        return (a, b) => {
          const aName = (a.username || '').toLowerCase();
          const bName = (b.username || '').toLowerCase();
          const comparison = aName.localeCompare(bName);
          return comparison * (isAsc ? 1 : -1);
        };
      },
      async fetch() {
        try {
          this.isLoader = true;
          this.data = await getContacts();
          this.isLoader = false;
        } catch (error) {
          console.error(error);
        }
      },

      async addMsgr() {
        if (!this.selectedUser) return;
        try {
          this.isLoader = true;
          const { id, details } = this.activeRow;
          await addContactMsgr(id, details, this.currentEmail, '');
          this.$emit('update');
        } catch (error) {
          console.error(error);
        } finally {
          this.isLoader = false;
        }
      },
      async deleteMsgr() {
        if (!this.activeRow) return;
        try {
          this.isLoader = true;
          await deleteContact(this.activeRow.id);
          await this.fetch();
        } catch (error) {
          console.error(error);
        } finally {
          this.isLoader = false;
        }
      },
      close() {
        this.$emit('close');
      },
      onRowClick(id) {
        this.rowActiveId = id;
      },
    },
  };
</script>

<style>
  .modalLink .settings-modal_modal_3LaCC {
    width: fit-content;
    max-width: 90%;
  }
</style>
<style lang="scss" module>
  .modalLink {
    display: flex;
    z-index: 3;
  }
  .loader {
    display: flex;
    justify-content: center;
    align-items: center;
    height: 300px;
    width: 1220px;
  }
  .wrapper {
    display: flex;
    padding: 10px;
    display: grid;
    grid-template-columns: 1fr 1fr;
  }

  .container {
    display: flex;
    flex-direction: column;
    max-width: 600px;
    overflow-y: auto;
    height: 300px;
  }

  .container::-webkit-scrollbar {
    display: none;
  }
  .expandArea {
    cursor: pointer;
    display: flex;
    height: 30px;
    align-items: center;
  }

  .header {
    margin: 0 20px 10px;
    text-align: center;
  }

  .strong {
    font-weight: 700 !important;
  }

  .button {
    height: 30px;
    cursor: pointer;
    width: 95px;
    background: #2985bf;
    border: 2px solid #2985bf;
    border-radius: 2px;
    font: inherit;
    font-size: 14px;
    text-align: center;
    color: #ffffff;
  }

  .disabled {
    background: $branchColor;
    border: $branchColor;
    cursor: auto;
  }
</style>
